import { Popconfirm, Tooltip, Typography } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, UnlockOutlined } from '@ant-design/icons';
const { Text } = Typography;

export const USERMANAGEMENT_COLUMNS_HEAD = (confirmDelete, viewTemp, editUserFun, generateTempPass) => {
    return [
        {
            title: 'Serial No.',
            dataIndex: 'serial_no',
            align: 'left',
        },
        {
            title: 'Employee Name',
            dataIndex: '',
            align: 'left',
            render: (ele) => {
                return <Text style={{ wordBreak: 'break-word' }}>{ele.first_name} {ele.last_name}</Text>
            }
        },
        {
            title: 'Email ID',
            dataIndex: 'email',
            align: 'left',
            render: (ele) => {
                return <Text style={{ wordBreak: 'break-word' }}>{ele}</Text>
            }
        },
        {
            title: 'User Group',
            dataIndex: '',
            align: 'left',
            render: (ele) => {
                return <Text style={{ wordBreak: 'break-word' }}>{ele?.group[0] === "is_user" ? "User" : ele?.group[0] === "is_admin" ? "Admin" : ""}</Text>
            }
        },
        {
            title: 'Actions',
            dataIndex: '',
            align: 'right',
            width: '200px',
            render: (ele) => {
                return (<div>
                    {!ele?.is_active &&
                        <Tooltip title="Generate Temporary Password" color="#526ebf">
                            <UnlockOutlined style={{
                                backgroundColor: '#1677ff42',
                                color: '#526ebf',
                                borderRadius: '3px',
                                padding: '6px',
                                fontSize: '16px',
                                cursor: 'pointer',
                                marginRight: '15px'
                            }}
                                onClick={() => generateTempPass(ele)}
                            />
                        </Tooltip>
                    }
                    {ele?.temp_pass &&
                        <Tooltip title="View Temporary Password" color="#1f338c">
                            <EyeOutlined style={{
                                backgroundColor: '#526ebf3d',
                                color: '#1f338c',
                                borderRadius: '3px',
                                padding: '6px',
                                fontSize: '16px',
                                cursor: 'pointer',
                                marginRight: '15px'
                            }}
                                onClick={() => viewTemp(ele)}
                            />
                        </Tooltip>
                    }
                    <Tooltip title="Edit User" color="#11b052">
                        <EditOutlined style={{
                            backgroundColor: '#0eff7742',
                            color: '#11b052',
                            borderRadius: '3px',
                            padding: '6px',
                            fontSize: '16px',
                            cursor: 'pointer',
                            marginRight: '15px'
                        }}
                            onClick={() => editUserFun(ele)}
                        />
                    </Tooltip>
                    <Tooltip title="Delete User" color="#F84646">
                        <Popconfirm
                            placement="bottomRight"
                            title="Delete the User"
                            description="Are you sure You want to delete this User?"
                            onConfirm={() => confirmDelete(ele)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <DeleteOutlined style={{
                                backgroundColor: 'rgba(248, 70, 70, 0.15)',
                                color: '#F84646',
                                borderRadius: '3px',
                                padding: '6px',
                                fontSize: '16px',
                                cursor: 'pointer',
                            }} />
                        </Popconfirm>
                    </Tooltip>
                </div>)
            },
        },
    ]
};

export const ADD_USER_INITIAL_OBJECT = {
    firstName: '',
    lastName: '',
    email: '',
    user: "",
    errorMessage: {
        firstName: '',
        lastName: '',
        email: '',
        user: '',
    }
}